
import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { RussianRuble } from "lucide-react";

interface FinancialSectionProps {
  discount: number;
  depositAmount: number;
  promoCode: string;
  totalAmount: number;
  onDiscountChange: (discount: number) => void;
  onDepositAmountChange: (amount: number) => void;
  onPromoCodeChange: (code: string) => void;
  isLoading?: boolean;
}

export const FinancialSection = ({
  discount,
  depositAmount,
  promoCode,
  totalAmount,
  onDiscountChange,
  onDepositAmountChange,
  onPromoCodeChange,
  isLoading = false
}: FinancialSectionProps) => {
  return (
    <div className="bg-muted/50 rounded-lg border p-4 px-[8px]">
      <h3 className="text-lg font-medium mb-4 flex items-center">
        <RussianRuble className="mr-2 h-5 w-5 text-blue-600" />
        Финансовая информация
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div>
          <Label htmlFor="discount">Скидка (%)</Label>
          <Input
            id="discount"
            type="number"
            min="0"
            max="100"
            value={discount}
            onChange={e => onDiscountChange(Number(e.target.value))}
            disabled={isLoading}
          />
        </div>
        <div>
          <Label htmlFor="depositAmount">Депозит</Label>
          <Input
            id="depositAmount"
            type="number"
            min="0"
            value={depositAmount}
            onChange={e => onDepositAmountChange(Number(e.target.value))}
            disabled={isLoading}
          />
        </div>
        <div>
          <Label htmlFor="promoCode">Промокод</Label>
          <Input
            id="promoCode"
            value={promoCode}
            onChange={e => onPromoCodeChange(e.target.value)}
            disabled={isLoading}
            placeholder="Введите промокод"
          />
        </div>
        <div>
          <Label htmlFor="totalAmount">Общая сумма</Label>
          <Input
            id="totalAmount"
            value={`${totalAmount.toFixed(2)}₽`} 
            disabled
            className="bg-background font-medium text-green-600"
          />
        </div>
      </div>
    </div>
  );
};
